import * as React from "react";
import Box from "@mui/material/Box";
import { TextareaAutosize } from "@mui/material";

export const TextArea = (props) => {
  return (
    <Box sx={{ width: "100%" }}>
      <TextareaAutosize
        aria-label="textarea"
        placeholder={props.placeholder}
        minRows={5} // Minimum number of rows to display (optional)
        style={{
          width: "100%",
          resize: "none",
          padding: "16px",
          borderColor: "#777dea54",
          borderWidth: "1px",
          outlineColor: "#777dea54",
          borderRadius: "8px",
          "&:focus": {
            borderColor: "#777dea54", // Border color on focus
          },
        }}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        id={props.id}
      />
    </Box>
  );
};
